import ModalBody from './ModalBody.js';
import ModalContainer from './ModalContainer.js';
import ModalContext from './ModalContext.js';
import ModalHeader from './ModalHeader.js';
import ModalFooter from './ModalFooter.js';
import ModalMargin from './ModalMargin.js';
import ModalPadding from './ModalPadding.js';

var Modal = {
  Body: ModalBody,
  Container: ModalContainer,
  Context: ModalContext,
  Footer: ModalFooter,
  Header: ModalHeader,
  Margin: ModalMargin,
  Padding: ModalPadding
};

export { Modal as default };
//# sourceMappingURL=index.js.map
